export default {
    directives: {
        'click-outside': {
            beforeMount(element, binding) {

                // Set the event handler for a click outside of our element as a property on the element.
                // This way, if the element gets unbound, we can easily access the event listener for // removal.
                element.__clickOutsideHandler = event => {

                    let blnGo = true;

                    //Check each element in bubbling path for classes, when you see flatpickr ignore the click-outside
                    event.composedPath().forEach(function (val, index) {
                        if (val.classList && val.classList.contains('flatpickr-calendar')) {
                            blnGo = false;
                        }
                    });

                    if (!blnGo || element == event.target || element.contains(event.target)) {
                        return;
                    }

                    binding.value();
                    event.stopPropagation();
                };

                //Add possibility to close with esc key
                element.__escapeHandler = event => {
                    if (event.keyCode === 27) {
                        binding.value();
                    }
                };

                document.addEventListener('click', element.__clickOutsideHandler);
                document.addEventListener('keyup', element.__escapeHandler);
            },
            unmounted() {
                if (typeof element === "undefined")
                    return;

                document.removeEventListener('click', element.__clickOutsideHandler);
                document.removeEventListener('keyup', element.__escapeHandler);
                element.__clickOutsideHandler = null;
                element.__escapeHandler = null;
            },
        },
    },
};
